// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetGiftcardResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type WidgetGiftcardApiResponse = {
	id: string;
	realPrice: number;
	onlinePrice: number;
	label: string;
	description: string | null;
	cardColor: string;
	textColor: string | null;
	backgroundOverlayDisplay: boolean;
	icon: string | null;
	logo: string | null;
	backgroundImage: string | null;
	expiresAt: string;
};

export type WidgetGiftcard = {
	id: string;
	realPrice: number;
	onlinePrice: number;
	label: string;
	description: string | null;
	cardColor: string;
	textColor: string | null;
	backgroundOverlayDisplay: boolean;
	icon: string | null;
	logo: string | null;
	backgroundImage: string | null;
	expiresAt: DateTime;
};

export function hydrateWidgetGiftcard(data: WidgetGiftcardApiResponse): WidgetGiftcard {
	return {
		...data,
		expiresAt: DateTimefromISO(data.expiresAt)!,
	};
}